import Select from "@/common/components/Select";
import { establishmentActionsControlStyles } from "@/common/components/Select/styles";
import { useProducts } from "@/common/hooks/queries/useProducts";
import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { ProductData } from "@/common/types/product.type";
import { Option } from "@/common/types/option";
import { useEstablishmentMap } from "@/features/establishments/stores/useEstablishmentMap.store";
import { EstablishmentMapAction } from "../../types/action";

const EstablishmentMapActionPriceSearch = () => {
  const { action, updateAction } = useEstablishmentMap();

  const [searchProduct, setSearchProduct] = useDebounce('');

  const { data: productOptions } = useProducts({
    filters: {
      search: searchProduct,
      onlyFuel: true,
    },
    mapper: Mapper.mapToOptions<ProductData>({ valueFieldName: 'id', labelFieldName: 'display_name' }),
  });

  return (
    <div className="flex items-center gap-4">
      <p>Selecione o produto:</p>

      <Select
        options={productOptions}
        onInputChange={setSearchProduct}
        className="min-w-[150px]"
        customStyles={establishmentActionsControlStyles}
        onChange={(option) => updateAction({ ...action, properties: { product_id: (option as Option).value || '' } } as EstablishmentMapAction)}
      />
    </div>
  );
};

export default EstablishmentMapActionPriceSearch;
